export default "__VITE_ASSET__BtY62HyN__"